import Link from "../../Link";

const Spring = () => {
    return (
        <div>
            <Link url="https://campus.open-bootcamp.com/cursos/14" title={"OpenBootcamp Spring(Java)"} />
        </div>
    );
}

export default Spring;